var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUiLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z",
    fill: "#18204D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7843 20.9277L20.9285 28.7836L24.1458 32.0009L32.0017 24.1451L28.7843 20.9277Z",
    fill: "#FFE458"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2722 13.4389L18.8933 20.0601C18.8878 20.1093 18.885 20.1593 18.885 20.21C18.885 20.9417 19.4782 21.535 20.21 21.535C20.9417 21.535 21.535 20.9417 21.535 20.21C21.535 19.4782 20.9417 18.885 20.21 18.885C20.1593 18.885 20.1093 18.8878 20.0601 18.8933L13.4391 12.2723L25.2099 14.5H25.2199L27.3599 22.36L22.3599 27.36L14.4999 25.21L12.2722 13.4389Z",
    fill: "#B5CDFB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiLogo);
export default __webpack_public_path__ + "static/media/ui-logo.4fdcb0151491eac5966b58a03753803c.svg";
export { ForwardRef as ReactComponent };